module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lobby-theme-menu-bar"
  }, [_c('ul', {
    staticClass: "lobby-theme-menu-bar-inner nav navbar-nav"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('li', {
      staticClass: "dropdown",
      class: _vm.widthClass
    }, [_c('a', {
      staticClass: "dropdown-toggle",
      class: {
        'active': _vm.isModuleActive(menu)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return menu.click()
        }
      }
    }, [_vm._v(_vm._s(menu.name))]), _vm._v(" "), (menu.menus && menu.menus.length) ? _c('ul', {
      staticClass: "dropdown-menu"
    }, _vm._l((menu.menus), function(menu1) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return menu1.click()
          }
        }
      }, [_vm._v(_vm._s(menu1.name))])])
    }), 0) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-16e6cdc2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/theme/widget/MenuBarView.vue
// module id = 953
// module chunks = 1